<template>
  <div class="gc-tailwind-tooltip gc-shadow-md">
    <div class="tooltip" :class="[`tooltip-${position}`, `${position}-arrow`]">
      <span>
        <slot />
      </span>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from '@vue/composition-api';
export default defineComponent({
  props: {
    position: {
      type: String,
      default: 'bottom',
    },
  },
});
</script>
<style lang="scss">
.gc-tailwind-tooltip {
  position: relative;
  .tooltip {
    @apply gc-z-10 gc-px-3 gc-py-2 gc-text-sm gc-rounded-md gc-bg-white;
    position: absolute;
    border: 1px solid var(--v-error-base);
    min-width: max-content;
    max-width: 100%;
  }
  .tooltip-top,
  .tooltip-bottom {
    left: 50%;
    transform: translateX(-50%);
  }
  .tooltip-top {
    bottom: 10px;
  }
  .bottom-arrow {
    &:before,
    &:after {
      content: '';
      position: absolute;
      top: -20px;
      left: 50%;
      translate: -50%;
      height: 0;
      width: 0;
      border: 10px solid transparent;
    }
    &:before {
      top: -21px;
      border-bottom-color: var(--v-error-base);
    }
    &:after {
      border-bottom-color: white;
    }
  }
  .tooltip-bottom {
    top: 50px;
  }
  .top-arrow {
    &:before,
    &:after {
      content: '';
      position: absolute;
      bottom: -20px;
      left: 50%;
      translate: -50%;
      height: 0;
      width: 0;
      border: 10px solid transparent;
    }
    &:before {
      bottom: -21px;
      border-top-color: var(--v-error-base);
    }
    &:after {
      border-top-color: white;
    }
  }
}
.tailwind-tooltip-bottom-enter-active,
.tailwind-tooltip-bottom-leave-active {
  transition: all 0.1s ease-out;
}
.tailwind-tooltip-bottom-enter,
.tailwind-tooltip-bottom-leave-to {
  translate: 0 -10px;
  opacity: 0;
}
.tailwind-tooltip-bottom-enter-to,
.tailwind-tooltip-bottom-leave {
  opacity: 1;
}
.tailwind-tooltip-top-enter-active,
.tailwind-tooltip-top-leave-active {
  transition: all 0.1s ease-out;
}
.tailwind-tooltip-top-enter,
.tailwind-tooltip-top-leave-to {
  translate: 0 10px;
  opacity: 0;
}
.tailwind-tooltip-top-enter-to,
.tailwind-tooltip-top-leave {
  opacity: 1;
}
</style>
